import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './StudentList.css';


const StudentList = () =>{
  const [students, setStudents] = useState([]);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const [editingStudent, setEditingStudent] = useState(null);

  const startEditing = (student) => {
    setEditingStudent(student);
  };

  const cancelEditing = () => {
    setEditingStudent(null);
  }

  const [selectedStudent,setSelectedStudent] = useState(null);

  const [showAddForm, setShowAddForm] = useState(false);


  // Загрузка списка студентов
  const fetchStudents = () => {
    fetch(`${process.env.REACT_APP_API_URL}/students`)
      .then(res => res.json())
      .then(data => setStudents(data))
      .catch(err => console.error('Ошибка при загрузке студентов:', err));
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  // Обработчик добавления
  const handleAddStudent = async (e) => {
    e.preventDefault();

    const newStudent = { name, email, phone };

    const response = await fetch(`${process.env.REACT_APP_API_URL}/students`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newStudent)
    });

    if (response.ok) {
      setName('');
      setEmail('');
      setPhone('');
      fetchStudents(); // перезагрузить список
    } else {
      console.error('Ошибка при добавлении студента');
    }
  };

  const handleDelete = async(id) => {
    const confirm = window.confirm('Are you sure?');
    if(!confirm) return;

    const response = await fetch(`${process.env.REACT_APP_API_URL}/students/${id}`, { method: 'DELETE'})

    if(response.ok){
      fetchStudents();
    } else {
      console.error('Error during deleting');
    }
  };

  const fetchStudentById = async(id) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/students/${id}`);
    if(response.ok){
      const data = await response.json();
      setSelectedStudent(data);
    } else {
      console.error('Error during getting');
    }
  };
  

  return(
    <div>
      <h2>Students List</h2>
      <ul>
        {students.map(student => (
          <li key={student.id} className="student-item">
          <div className="student-content">
            <div>
              <strong>{student.name}</strong> <i>{student.email}</i> {student.phone}
            </div>
            <div className="button-group">
              <button onClick={() => handleDelete(student.id)}>Delete</button>
              <button onClick={() => startEditing(student)} style={{ marginLeft: '10px' }}>Edit</button>
              <button onClick={() => fetchStudentById(student.id)} style={{ marginLeft: '10px' }}>Details</button>
            </div>
          </div>
        </li>
        ))}
      </ul>

      {editingStudent && (
        <div style={{marginTop: '20px'}}>
          <h3>Edit student</h3>
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              const response = await fetch(`${process.env.REACT_APP_API_URL}/students/${editingStudent.id}`,{
                method: 'PUT',
                headers:{'Content-Type': 'application/json'},
                body: JSON.stringify(editingStudent)
              });

              if(response.ok){
                fetchStudents();
                cancelEditing();
              } else {
                console.error('Error during editing');
              }
            }}
          >
            <input
              type='text'
              placeholder='Name'
              value={editingStudent.name}
              onChange={(e) => setEditingStudent({ ...editingStudent, name: e.target.value })}
              maxLength={50}
              required
            />
            <input
              type='email'
              placeholder='Email'
              value={editingStudent.email}
              onChange={(e) => setEditingStudent({ ...editingStudent, email: e.target.value })}
              pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
              maxLength={50}
              required
            />
            <input
              type='text'
              placeholder='Phone'
              value={editingStudent.phone}
              onChange={(e) => setEditingStudent({ ...editingStudent, phone: e.target.value })}
              pattern='^\+380\d{9}$'
              required
            />
            <button type='submit'>Save</button>
            <button type='button' onClick={cancelEditing}>Cancel</button>
          </form>
        </div>
      )}

      {selectedStudent && (
        <div className="details-box">
          <h3>Student details</h3>
          <span>Id: {selectedStudent.id}</span><br/>
          <span>Name: {selectedStudent.name}</span><br/>
          <span>Email: {selectedStudent.email}</span><br/>
          <span>Phone: {selectedStudent.phone}</span><br/>          
          <button onClick={() => setSelectedStudent(null)}>Close</button>
        </div>
      )}

      {!showAddForm && (
        <button onClick={() => setShowAddForm(true)}>Add student</button>
      )}

      {showAddForm && (
         <div style={{ marginTop: '20px' }}>
         <h3>Add new student</h3>
         <form onSubmit={handleAddStudent}>
           <input
             type="text"
             placeholder="Name"
             value={name}
             onChange={(e) => setName(e.target.value)}
             maxLength={50}
             required
           />
           <input
             type="email"
             placeholder="Email"
             value={email}
             onChange={(e) => setEmail(e.target.value)}
             pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
             maxLength={50}
             required
           />
           <input
             type="tel"
             placeholder="Phone format +380XXXXXXXXX"
             value={phone}
             onChange={(e) => setPhone(e.target.value)}
             pattern="^\+380\d{9}$"
             required
           />
           <button type="submit">Save</button>
           <button
             type="button"
             onClick={() => {
               setShowAddForm(false);
               setName('');
               setEmail('');
               setPhone('');
             }}
             
           >
             Cancel
           </button>
         </form>
       </div>
      )}      
    </div>
  );
};

StudentList.propTypes = {};

StudentList.defaultProps = {};

export default StudentList;
